import { useState } from 'react';
import { Box, Card, CardContent, Divider, Typography } from '@mui/material';
import Header from '@/component/Header';
import AdminWalletForm from '@/component/stake-db/wallet/AdminWalletForm';
import AdminWalletList from '@/component/stake-db/wallet/AdminWalletList';

export default function StakeDbAdminWallet() {
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCreated = () => {
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flex: 1,
        flexDirection: 'column',
        gap: { xs: '16px', sm: '0px' },
      }}
    >
      <Card>
        <Header title="Stake-db 관리자 지갑 관리" />
        <Divider />
        <CardContent
          sx={{
            maxHeight: '80vh',
            overflow: 'auto',
          }}
        >
          <AdminWalletForm onCreated={handleCreated} />
          <Box mb={4} />
          <Divider />
          <Box mt={4} />
          <Typography variant="h6" sx={{ p: 2, pb: 0 }}>
            관리자 지갑 리스트
          </Typography>
          <AdminWalletList refreshKey={refreshKey} />
        </CardContent>
      </Card>
    </Box>
  );
}
